import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../user/user';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UseraddService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  GetMenu(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/TeamApi/GetMenuList/');
  }
  GetAction()
    : Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/TeamApi/GetActionList/');
  }

  GetRequesttype(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/UserApi/GetRequesttype/');
  }

  GetMailid(maild) {
    return this.httpClient.get(this.baseUrl + 'api/UserApi/FindByMailId_User?mailid=' + maild)
  }

  GetImage(filename: string): Observable<any> {  
    return this.httpClient.post(this.baseUrl + 'api/UserApi/GetIcon/' + filename, { observe: 'response' });
  }
  GetById(userid: number) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<User[]>(this.baseUrl + 'api/UserApi');
  } 
  
  Post(formdata: FormData) {
    
   
    return this.httpClient.post(this.baseUrl + 'api/UserApi/add', formdata, { observe: 'response' })
  } 
  Put(formdata: FormData) {
   
    return this.httpClient.put(this.baseUrl + 'api/UserApi/Update', formdata, { observe: 'response' })
  }
  getadduserautologapiresult(inputstr:string){
    return this.httpClient.get(this.baseUrl + 'api/UserApi/getadduserautologapiresult?inputstr=' + inputstr);
  }
}

